import { useState } from 'react';
import { Popover } from 'src/core/ui';
import { InfoOutlineIcon } from 'src/svgs/Viagogo';

import * as styles from '../../TableColumns.css';
import { CustomColumnInstruction } from './CustomColumnInstruction';

export const CustomColumnInstructionPopover = () => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <Popover.Root open={showInfo}>
      <Popover.Trigger asChild>
        <div
          className={styles.iconContainer}
          onClick={() => setShowInfo((prev) => !prev)}
        >
          <InfoOutlineIcon withHoverEffect />
        </div>
      </Popover.Trigger>
      <Popover.Content align="center">
        <CustomColumnInstruction />
      </Popover.Content>
    </Popover.Root>
  );
};
